function PageController(){
	this.className			= "PageController";
	this.view				= null;
	this.glob				= "/**";
	this.viewData			= {};
	this.log				= false;
}
PageController.inheritsFrom( StandardController );

PageController.prototype.on = function() {
	this.resizeDelegate = jstage.addListener("resize", Igloo.delegate(this, this.onResize));
    this.onResize();
}

PageController.prototype.onResize = function() {
    if (this.log) console.log('%c[PageController]', 'background: orange', 'onResize')
    ScrollTrigger.refresh();
}

PageController.prototype.swap = function(onComplete){

	// Do Loading here

	if(this.view){
		this.baseController = Aviator.get("baseController");
		this.viewModel = this.baseController.viewModel;

		this.$page = this.baseController.$page;

		// Show the relevant view
		var details = this.viewModel.getTemplateDetails(this.view);
		if(!details){
			Igloo.debug("Couldn't find template: " + this.view);

		} else {
			this.updatePageClass(details);

			const compiled = Handlebars.compile(details.html);
			this.$page.html(compiled(Igloo.merge(details.data,this.viewData)));

			// Process image loading
			this.baseController.processImages(this.$page, onComplete);

			nav.addToLinks($("a"));

		}
	}

	return true;
};
PageController.prototype.updatePageClass = function(details){
	if(!details.name) return false;

	// Remove all classes starting with page-
	const classes = this.$page[0].className.split(" ").filter(c => !c.startsWith('page-'));

	// Add page class
	const pageClassNameParts = details.name.split("/");
	const pageGeneralName = pageClassNameParts[0];
	const pageSectionName = pageClassNameParts[1];

	classes.push(`page-${pageGeneralName}`);
	if(pageSectionName){
		classes.push(`page-${pageGeneralName}-${pageSectionName}`);
	}

	// Set new classes
	this.$page[0].className = classes.join(" ").trim();
}